export default "__VITE_ASSET__CHr$kNzm__"